"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectFormRevisionNumberSchema = exports.accompanyingReportSchema = exports.createTaskSchema = exports.createProjectSchema = exports.updatePhotoDocumentationSchema = exports.createPhotoDocumentationSchema = exports.createWorkspaceSchema = exports.createProjectFormRichTextHelpSchema = exports.updateUserRoleSchema = exports.inviteUserSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
exports.inviteUserSchema = zod_1.z.object({
    email: zod_1.z.string({
        message: "Pole je povinné"
    }).email("Je potřeba zadat validní email"),
    role: zod_1.z.object({
        value: zod_1.z.nativeEnum(enums_1.UserRoleEnum)
    })
});
exports.updateUserRoleSchema = zod_1.z.object({
    role: zod_1.z.nativeEnum(enums_1.UserRoleEnum)
});
exports.createProjectFormRichTextHelpSchema = zod_1.z.object({
    name: zod_1.z.string().optional(),
    text: zod_1.z.string(),
    key: zod_1.z.string(),
    formEnum: zod_1.z.nativeEnum(enums_1.ProjectFormEnum)
});
exports.createWorkspaceSchema = zod_1.z.object({
    workspace: zod_1.z.object({
        name: zod_1.z.string({
            message: "Pole je povinné"
        }),
        slug: zod_1.z.string({
            message: "Pole je povinné"
        })
    }),
    user: zod_1.z.object({
        email: zod_1.z.string({
            message: "Pole je povinné"
        }).email("Je potřeba zadat validní email"),
        password: zod_1.z.string({
            message: "Pole je povinné"
        }),
        name: zod_1.z.string({
            message: "Pole je povinné"
        })
    })
});
exports.createPhotoDocumentationSchema = zod_1.z.object({
    image: zod_1.z.any(),
    description: zod_1.z.string().optional(),
    room: zod_1.z.string().optional()
});
exports.updatePhotoDocumentationSchema = zod_1.z.object({
    description: zod_1.z.string().optional(),
    room: zod_1.z.string().optional()
});
exports.createProjectSchema = zod_1.z.object({
    name: zod_1.z.string({
        message: "Pole je povinné"
    }),
    subject: zod_1.z.string({
        message: "Pole je povinné"
    }),
    number: zod_1.z.string({
        message: "Pole je povinné"
    }),
    investorId: zod_1.z.string({ message: "Pole je povinné" }),
    latitude: zod_1.z.number({ message: "Vyberte polohu na mapě" }),
    buildingPermit: zod_1.z.nativeEnum(enums_1.ProjectFormCategoryVariantEnum).optional(),
    demolitionPermit: zod_1.z.nativeEnum(enums_1.ProjectFormCategoryVariantEnum).optional()
});
exports.createTaskSchema = zod_1.z.object({
    id: zod_1.z.any(),
    title: zod_1.z.string({
        message: "Pole je povinné"
    }),
    description: zod_1.z.string().nullable().optional(),
    assignedTo: zod_1.z.string().nullable().optional(),
    due: zod_1.z.any(),
    project: zod_1.z.string().nullable().optional(),
    contact: zod_1.z.string().nullable().optional(),
    doneAt: zod_1.z.any()
});
exports.accompanyingReportSchema = zod_1.z.object({
    a1: zod_1.z.object({
        constructionName: zod_1.z.string({
            required_error: "povinné pole"
        }),
        documentationAuthor: zod_1.z.object({
            author: zod_1.z.string({
                required_error: "povinné pole"
            }),
            authorizationNumber: zod_1.z.string({
                required_error: "osoba bez autorizace"
            })
        }),
        primaryDocumentationAuthor: zod_1.z.object({
            author: zod_1.z.string({
                required_error: "povinné pole"
            }),
            authorizationNumber: zod_1.z.string({
                required_error: "osoba bez autorizace"
            })
        }),
        otherAuthors: zod_1.z
            .array(zod_1.z.object({
            authorizationNumber: zod_1.z.string({
                required_error: "osoba bez autorizace"
            }),
            label: zod_1.z.string({
                required_error: "povinné pole"
            }),
            author: zod_1.z.string({
                required_error: "povinné pole"
            }),
            indexIdentifier: zod_1.z.string({
                required_error: "povinné pole"
            })
        }))
            .min(1, { message: "musí být přidán alespoň jeden autor" }),
        surveyingEngineers: zod_1.z
            .array(zod_1.z.object({
            authorizationNumber: zod_1.z.string({
                required_error: "osoba bez autorizace"
            }),
            author: zod_1.z.string({
                required_error: "povinné pole"
            }),
            indexIdentifier: zod_1.z.string({
                required_error: "povinné pole"
            })
        }))
            .nullable(), // Corresponds to Yup.array().nullable()
        places: zod_1.z.array(zod_1.z.object({
            municipality: zod_1.z
                .object({
                kuKod: zod_1.z.string({ required_error: "povinné pole" }),
                krajKod: zod_1.z.string({ required_error: "povinné pole" }),
                krajNazev: zod_1.z.string({ required_error: "povinné pole" }),
                okresKod: zod_1.z.string({ required_error: "povinné pole" }),
                nuts4: zod_1.z.string({ required_error: "povinné pole" }),
                okresNazev: zod_1.z.string({ required_error: "povinné pole" }),
                obecNazev: zod_1.z.string({ required_error: "povinné pole" }),
                obecKod: zod_1.z.string({ required_error: "povinné pole" }),
                kuNazev: zod_1.z.string({ required_error: "povinné pole" }),
                kuPrac: zod_1.z.string({ required_error: "povinné pole" }),
                mapa: zod_1.z.string({ required_error: "povinné pole" }),
                ciselnaRada: zod_1.z.string({ required_error: "povinné pole" }),
                platnostOd: zod_1.z.string({ required_error: "povinné pole" }),
                platnostDo: zod_1.z.string().nullable(), // matches Yup.string().nullable()
                praresKod: zod_1.z.string({ required_error: "povinné pole" }),
                praresNazev: zod_1.z.string({ required_error: "povinné pole" }),
                poznamka: zod_1.z.string().nullable()
            })
                .nullable(), // matches Yup.object().nullable().required()
            siteFacilities: zod_1.z.boolean({
                required_error: "povinné pole"
            }),
            statutoryServitudes: zod_1.z.boolean({
                required_error: "povinné pole"
            })
        }))
    }),
    a1c: zod_1.z.object({
        purpose: zod_1.z.string({
            required_error: "povinné pole"
        })
    }),
    a2: zod_1.z.object({
        baseDocumentations: zod_1.z
            .array(zod_1.z.object({
            indexIdentifier: zod_1.z.string({
                required_error: "povinné pole"
            })
        }))
            .nullable() // matches Yup.array().nullable()
    }),
    a3: zod_1.z.object({
        enclosedSpace: zod_1.z.number({
            required_error: "povinné pole",
            invalid_type_error: "musí být číslo"
        }),
        builtUpArea: zod_1.z.number({
            required_error: "povinné pole",
            invalid_type_error: "musí být číslo"
        }),
        floorArea: zod_1.z.number({
            required_error: "povinné pole",
            invalid_type_error: "musí být číslo"
        }),
        numAboveGroundFloors: zod_1.z.number({
            required_error: "povinné pole",
            invalid_type_error: "musí být číslo"
        }),
        numUndergroundFloors: zod_1.z.number({
            required_error: "povinné pole",
            invalid_type_error: "musí být číslo"
        }),
        usageMethod: zod_1.z.string({
            required_error: "povinné pole"
        }),
        constructionType: zod_1.z.object({
            value: zod_1.z.string({ required_error: "povinné pole" })
        }),
        heatingMethod: zod_1.z.object({
            value: zod_1.z.string({ required_error: "povinné pole" })
        }),
        waterConnection: zod_1.z.object({
            value: zod_1.z.string({ required_error: "povinné pole" })
        }),
        sewerConnection: zod_1.z.object({
            value: zod_1.z.string({ required_error: "povinné pole" })
        }),
        gasConnection: zod_1.z.object({
            value: zod_1.z.string({ required_error: "povinné pole" })
        }),
        elevator: zod_1.z.object({
            value: zod_1.z.string({ required_error: "povinné pole" })
        })
    }),
    a4: zod_1.z.object({
        depthOfConstruction: zod_1.z.number({
            required_error: "povinné pole",
            invalid_type_error: "musí být číslo"
        }),
        heightOfConstruction: zod_1.z.number({
            required_error: "povinné pole",
            invalid_type_error: "musí být číslo"
        }),
        numberOfPeople: zod_1.z.number({
            required_error: "povinné pole",
            invalid_type_error: "musí být číslo"
        }),
        // For date fields, Yup’s .nullable().required() can be somewhat contradictory.
        // Below we assume a required date and display a format error if parsing fails.
        plannedStartDate: zod_1.z.date({
            required_error: "povinné pole",
            invalid_type_error: "nesprávný formát"
        }),
        plannedEndDate: zod_1.z.date({
            required_error: "povinné pole",
            invalid_type_error: "nesprávný formát"
        })
    })
});
exports.projectFormRevisionNumberSchema = zod_1.z.object({
    revisionNumber: zod_1.z.number({ message: "Musí být číslo" }).min(1, { message: "Číslo revize musí být minimálně kladné" }),
    projectFormType: zod_1.z.nativeEnum(enums_1.ProjectFormTypeEnum, { message: "Nesprávná hodnota" }),
    project: zod_1.z.string({ message: "Je potřeba vybrat projekt" })
});
